export default __webpack_public_path__ + "static/media/first-step-cg-create-plwd.f00a6da3.png";